import { EventEmitter, Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ApiCollectionResponse, Category, Tag, } from '../app/app.interfaces';

@Injectable()
export class CategoryService {

  public initialized: EventEmitter<void> = new EventEmitter();
  public isInitialized: boolean = false;
  public categories: Category[] = null;

  public activeCategory: Category = null;

  constructor(private apiService: ApiService) {}

  public getAllCategories(): Promise<Category[]> {
    return new Promise<Category[]>((resolve) => {
      this.afterInit().then(() => {
        resolve(this.categories);
      })
    });
  }

  public loadCategories(): void {
    this.apiService.getCollection('categories').then((apiResponse: ApiCollectionResponse) => {
      this.categories = apiResponse.items;
      this.isInitialized = true;
      this.initialized.emit();
    }).catch((err) => {
      console.error(err);
    });
  }

  public setActiveCategory(category: Category){
    if(category) {
      let currentActive = this.categories.find(category => category.active);
      if (currentActive) currentActive.active = false;

      category.active = true;
      this.activeCategory = category;
    }
  }

  public setActiveCategoryById(categoryId: Number): Promise<Category> {

    return new Promise((resolve, reject) => {
      this.afterInit().then(() => {
        let newActiveCategory = this.findById(categoryId);
        if(!newActiveCategory) {
          reject();
        }
        else {
          this.setActiveCategory(newActiveCategory);
          resolve(newActiveCategory);
        }

      });
    });
  }

  private findById(categoryId: Number): Category {
    if(!this.isInitialized) return null;
    return this.categories.find(category => category.id === categoryId);
  }


  public searchByTitle(title: string): Promise<Category[]> {

    return new Promise<Category[]>((resolve) => {

      this.afterInit().then(() => {
        const regex = new RegExp(title,"i");
        console.log(this.categories);
        const foundCats = this.categories.filter(cat => {
          return cat.title.search(regex) !== -1;
        });
        resolve(foundCats);
      })

    });

  }

  private afterInit(): Promise<void> {
    return new Promise((resolve) => {
      if (this.isInitialized) {
        resolve();
      }
      else {
        this.initialized.subscribe(() => {
          resolve();
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/category.service.ts